import store from '../store';

class MT4Platform {

    constructor() {
        this.user = store.state.user;
    }

    fromExcelToTrades(rawTrades, brokerToLink) {
        let trades = [];

        rawTrades.forEach((trade) => {
            try {
                let tradeToAdd = {
                    user: {id: this.user.id, login: this.user.username},
                    brokerAccount: {identifier: this.matchIndexes(trade, 'account'), broker: {id: brokerToLink},},
                    assetTicker: this.matchIndexes(trade, 'asset'),
                    side: this.matchIndexes(trade, 'side'),
                    openTime: this.convertDate(this.matchIndexes(trade, 'openTime')),
                    closeTime: this.convertDate(this.matchIndexes(trade, 'closeTime')),
                    openPrice: Number(this.removeCurrency(this.matchIndexes(trade, 'openPrice'))),
                    closePrice: Number(this.removeCurrency(this.matchIndexes(trade, 'closePrice'))),
                    netProfit: Number(this.removeCurrency(this.matchIndexes(trade, 'grossProfit'))),
                    commissions: 0,
                    pipValue: 0,
                    stopLossPrice: 0,
                };

                let priceDistance = Math.abs(tradeToAdd.openPrice - tradeToAdd.closePrice);
                tradeToAdd.pipValue = (priceDistance > 0.0) ? (Math.abs(tradeToAdd.netProfit) / (priceDistance)).toFixed(2) : 0;
                tradeToAdd.netProfit = tradeToAdd.netProfit - Math.abs(tradeToAdd.commissions);
                if (tradeToAdd.stopLossPrice === 0)
                    tradeToAdd.stopLossPrice = (tradeToAdd.side === 'BUY') ? tradeToAdd.openPrice - priceDistance : tradeToAdd.openPrice + priceDistance;
                trades.push(tradeToAdd);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log("There's an error");
            }
        });

        return trades;
    }

    matchIndexes(trade, itemType) {
        switch (itemType) {
            case 'account':
                return trade[0];
            case 'asset':
                return trade[1].toUpperCase();
            case 'side':
                return trade[4].includes('-')? 'SELL':'BUY';
            case 'openTime':
                return trade[2];
            case 'closeTime':
                return trade[5];
            case 'openPrice':
                return trade[3];
            case 'closePrice':
                return trade[6];
            case 'grossProfit':
                return trade[10];
        }
    }

    convertDate(stringDate) {
        let array = stringDate.split(' ');
        // Date related
        let date = array[0].split('.');
        let year = date[2];
        let month = date[1];
        let day = date[0];

        // Time related
        let time = array[1].split(':');
        let hour = time[0];
        let minute = time[1];
        let seconds = time[2];
        return new Date(year, month - 1, day, hour, minute, seconds);
    }
    removeCurrency(string) {
        let newString = string.toString();
        let currencies = ['$', '€', '£', '¥', '₽', '₺', 'CHF', 'R', 'S', '₩', '₫', ' '];
        currencies.forEach((currency) => { newString = newString.replace(currency, '') });
        newString = newString.replace(',', '.');
        return newString;
    }
}

export default new MT4Platform();
